// TODO: 命名
export const mediaQueryString = {
  desktop: 'screen and (min-width: 992px)',
  phone: 'screen and (max-width: 991px)',
} as const;

export const commonConfig = {
  headerHeight: 69,
  initialPageIndicatorDuration: 1000, // 最低でもこの時間は表示させる。初期化時間との差分
  kvDuration: 4000,
  mediaQueryString,
  navigationSwitchSelector: '.route', // pjaxによって入れ替わるdomのセレクタ
  pageIndicatorHideAnimationDuration: 1000,
  pageIndicatorShowAnimationDuration: 1000,
} as const;

const configure = () => {
  return {
    ...commonConfig,
    navigateFetchDelay: commonConfig.pageIndicatorShowAnimationDuration,
  };
};

export const config = configure();
